var map = {
	"./-bsc.js": [
		638,
		638
	],
	"./bsc.js": [
		5083,
		83
	],
	"./fork.js": [
		2103,
		103
	],
	"./index.js": [
		6435
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7321;
module.exports = webpackAsyncContext;